export const CREDIT = 'credit'
export const DEBIT = 'debit'
export const INVESTMENT = 'investment'
export const INVESTMENT_WITHDRAWAL = 'investment_withdrawal'